export default __webpack_public_path__ + "static/media/phone get the cult.50076f74.webp";